import React, { Component } from 'react';
import '../App.css';

const asset = (file) => `${process.env.PUBLIC_URL}/appstore/${file}`;

const portfolio = [
  {
    id: 'joker',
    name: '小丑牌 - 符号狂潮',
    shortName: '小丑牌',
    subtitle: '随机肉鸽策略卡牌游戏',
    category: '游戏',
    rating: '4.9',
    ratings: '2,187',
    version: '1.9.4',
    updated: '2025.09.20',
    accent: '#F2C45B',
    icon: asset('joker-icon.jpg'),
    screenshots: [asset('joker-1.webp'), asset('joker-2.webp'), asset('joker-3.webp')],
    appStore: 'https://apps.apple.com/cn/app/%E5%B0%8F%E4%B8%91%E7%89%8C-%E7%AC%A6%E5%8F%B7%E7%8B%82%E6%BD%AE/id6723865885',
    description:
      '结合德州扑克和 Roguelike 元素，通过增强筹码与倍率完成 RPG 关卡，抽卡、开包、升级牌型并收集小丑牌，构筑独一无二的 Build。'
  },
  {
    id: 'crossing',
    name: '穿越模拟器',
    shortName: '穿越模拟器',
    subtitle: '肉鸽构建文字冒险',
    category: '游戏',
    rating: '4.9',
    ratings: '249',
    version: '1.2.3',
    updated: '2025.08.25',
    accent: '#58D4A6',
    icon: asset('crossing-icon.jpg'),
    screenshots: [asset('crossing-1.webp'), asset('crossing-2.webp'), asset('crossing-3.webp')],
    appStore: 'https://apps.apple.com/cn/app/%E7%A9%BF%E8%B6%8A%E6%A8%A1%E6%8B%9F%E5%99%A8/id6742339011',
    description:
      '融合肉鸽构建与文字冒险模拟的策略回合游戏。定制角色，开启异世界穿越旅程，在连续选择中完成属于自己的故事。'
  },
  {
    id: 'hooked',
    name: '上钩了! - 悠闲钓鱼好时光',
    shortName: '上钩了!',
    subtitle: '后台挂机放置捕鱼养鱼模拟器',
    category: '娱乐',
    rating: '4.8',
    ratings: '85',
    version: '1.2.3',
    updated: '2026.06.25',
    accent: '#48C7E8',
    icon: asset('hooked-icon.jpg'),
    screenshots: [asset('hooked-1.webp'), asset('hooked-2.webp'), asset('hooked-3.webp')],
    appStore: 'https://apps.apple.com/cn/app/%E4%B8%8A%E9%92%A9%E4%BA%86-%E6%82%A0%E9%97%B2%E9%92%93%E9%B1%BC%E5%A5%BD%E6%97%B6%E5%85%89/id6760618326',
    description:
      '像素风休闲钓鱼与养鱼体验。解锁全国水域，收集超过 300 种鱼类图鉴，装饰鱼缸、互动养成并获得金币。'
  },
  {
    id: 'yztp',
    name: '与子同袍-汉服设计与百科',
    shortName: '与子同袍',
    subtitle: '开启汉服设计之旅',
    category: '参考',
    rating: '4.6',
    ratings: '3,808',
    version: '6.0.0',
    updated: '2026.02.16',
    accent: '#E86E5D',
    icon: asset('yztp-icon.jpg'),
    screenshots: [asset('yztp-1.webp'), asset('yztp-2.webp'), asset('yztp-3.webp')],
    appStore: 'https://apps.apple.com/cn/app/%E4%B8%8E%E5%AD%90%E5%90%8C%E8%A2%8D-%E6%B1%89%E6%9C%8D%E8%AE%BE%E8%AE%A1%E4%B8%8E%E7%99%BE%E7%A7%91/id1475409197',
    description:
      '同袍必备参考应用，形制、暗纹、绣花持续更新。用清晰资料与设计参考，帮助用户理解与创作汉服方案。'
  },
  {
    id: 'aiword',
    name: '完形词汇',
    shortName: '完形词汇',
    subtitle: '边读故事边背单词',
    category: '教育',
    rating: '4.9',
    ratings: '61',
    version: '1.5.6',
    updated: '2024.10.14',
    accent: '#8D7CFF',
    icon: asset('aiword-icon.jpg'),
    screenshots: [asset('aiword-1.webp'), asset('aiword-2.webp'), asset('aiword-3.webp')],
    appStore: 'https://apps.apple.com/cn/app/%E5%AE%8C%E5%BD%A2%E8%AF%8D%E6%B1%87/id1672818218',
    description:
      '让背单词变简单，把词汇学习放进故事阅读中。用户可以在上下文里理解、记忆和复习单词。'
  }
];

const heroApps = [portfolio[0], portfolio[2], portfolio[3]];

export default class Home extends Component {
  renderHeroPhone(app, index) {
    return (
      <div className={`hero-phone hero-phone-${index + 1}`} key={app.id}>
        <img src={app.screenshots[0]} alt={`${app.shortName} App Store 截图`} />
        <div className="hero-phone-badge">
          <img src={app.icon} alt={`${app.shortName} 图标`} />
          <span>{app.shortName}</span>
        </div>
      </div>
    );
  }

  renderProductCard(app, index) {
    return (
      <article
        className="portfolio-card reveal-card"
        key={app.id}
        style={{ '--accent': app.accent, '--delay': `${index * 90}ms` }}
      >
        <div className="portfolio-card-copy">
          <div className="app-identity">
            <img className="app-icon" src={app.icon} alt={`${app.shortName} 图标`} />
            <div>
              <span className="app-category">{app.category}</span>
              <h3>{app.name}</h3>
              <p>{app.subtitle}</p>
            </div>
          </div>

          <p className="app-description">{app.description}</p>

          <div className="app-metrics" aria-label={`${app.shortName} App Store 数据`}>
            <div>
              <strong>{app.rating}</strong>
              <span>评分</span>
            </div>
            <div>
              <strong>{app.ratings}</strong>
              <span>份评分</span>
            </div>
            <div>
              <strong>v{app.version}</strong>
              <span>{app.updated}</span>
            </div>
          </div>

          <a
            className="store-link"
            href={app.appStore}
            target="_blank"
            rel="noreferrer"
            aria-label={`在 App Store 查看 ${app.name}`}
          >
            App Store
            <span aria-hidden="true">↗</span>
          </a>
        </div>

        <div className="screenshot-strip" aria-label={`${app.shortName} 作品截图`}>
          {app.screenshots.map((shot, shotIndex) => (
            <figure className="shot-frame" key={shot}>
              <img
                src={shot}
                alt={`${app.shortName} 截图 ${shotIndex + 1}`}
                loading={index === 0 ? 'eager' : 'lazy'}
              />
            </figure>
          ))}
        </div>
      </article>
    );
  }

  render() {
    return (
      <main className="App">
        <header className="site-hero">
          <nav className="topbar" aria-label="网站导航">
            <a className="brand-mark" href="/">
              <img src={asset('yztp-icon.jpg')} alt="与子同袍图标" />
              <strong>成都与子同袍科技有限公司</strong>
            </a>
            <div className="topbar-links">
              <a href="#works">作品</a>
              <a href="#contact">联系</a>
            </div>
          </nav>

          <section className="hero-content" aria-label="公司介绍">
            <div className="hero-copy">
              <span className="eyebrow">App Store Portfolio</span>
              <h1>成都与子同袍科技有限公司</h1>
              <p>
                以游戏、传统文化工具与 AI 学习产品为核心，持续打磨轻量、耐玩、好用的移动体验。
              </p>
              <div className="hero-actions">
                <a href="#works" className="primary-action">
                  浏览作品
                  <span aria-hidden="true">↓</span>
                </a>
                <a href="mailto:tsc92321@gmail.com" className="ghost-action">
                  联系我们
                </a>
              </div>
            </div>

            <div className="hero-showcase" aria-label="精选作品截图">
              <div className="hero-screen-grid">{heroApps.map((app, index) => this.renderHeroPhone(app, index))}</div>
            </div>
          </section>

          <div className="hero-stats" aria-label="App Store 数据概览">
            <div>
              <strong>5</strong>
              <span>指定作品</span>
            </div>
            <div>
              <strong>6,390</strong>
              <span>App Store 评分</span>
            </div>
            <div>
              <strong>3</strong>
              <span>内容方向</span>
            </div>
          </div>
        </header>

        <section className="marquee-band" aria-hidden="true">
          <div className="marquee-track">
            {[...portfolio, ...portfolio].map((app, index) => (
              <span key={`${app.id}-${index}`}>{app.shortName}</span>
            ))}
          </div>
        </section>

        <section className="works-section" id="works">
          <div className="section-heading">
            <span className="eyebrow">Works</span>
            <h2>App Store 作品展示</h2>
            <p>截图、简介、版本与评分数据均根据 App Store 页面整理。</p>
          </div>
          <div className="portfolio-grid">{portfolio.map((app, index) => this.renderProductCard(app, index))}</div>
        </section>

        <section className="contact-section" id="contact">
          <div className="contact-copy">
            <span className="eyebrow">Contact</span>
            <h2>一起把下一个想法做得更顺手</h2>
            <p>欢迎通过邮箱联系产品合作、问题反馈或内容授权相关事宜。</p>
          </div>
          <a className="mail-card" href="mailto:tsc92321@gmail.com">
            <span>邮箱</span>
            <strong>tsc92321@gmail.com</strong>
          </a>
        </section>

        <footer className="App-footer">
          <div className="footer-brand">
            <strong>成都与子同袍科技有限公司</strong>
            <span>专注创新，持续更新</span>
          </div>
          <div className="record-info">
            <a href="http://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
              蜀ICP备2021023183号
            </a>
            <p>
              <img src={require('../img/police.png')} alt="" />
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004138"
                target="_blank"
                rel="noreferrer"
              >
                川公网安备 51019002004138号
              </a>
            </p>
          </div>
        </footer>
      </main>
    );
  }
}
